import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import { equipment } from '../data';
import SafeIcon from '../common/SafeIcon';

const Equipment = ({ onAddToCart }) => {
  const [addingId, setAddingId] = useState(null);

  const handleAdd = (item, e) => {
    e.stopPropagation();
    setAddingId(item.id);
    setTimeout(() => {
      onAddToCart(item);
      setAddingId(null);
    }, 600);
  };

  return (
    <section className="py-24 bg-cream" id="equipment">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeader 
          title="Tools of the Trade" 
          subtitle="Brew better with barista-approved gear."
          icon="Tool"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {equipment.map(item => (
            <div 
              key={item.id} 
              className="group cursor-pointer flex flex-col focus-within:ring-4 focus-within:ring-moss/20 rounded-sm"
              tabIndex="0"
              role="button"
              aria-label={`View ${item.name}`}
            >
              <div className="bg-gray-100 aspect-square overflow-hidden mb-4 relative flex items-center justify-center p-8">
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className="w-full h-full object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-espresso/0 group-hover:bg-espresso/5 transition-colors pointer-events-none"></div>
                
                {/* Quick Add Overlay */}
                <div className="absolute bottom-4 left-0 right-0 flex justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button 
                    onClick={(e) => handleAdd(item, e)}
                    disabled={addingId === item.id}
                    className="bg-espresso text-cream px-6 py-2 text-[10px] font-bold uppercase tracking-widest hover:bg-moss transition-colors shadow-xl disabled:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-moss"
                  >
                    {addingId === item.id ? 'Adding...' : 'Add to Cart'}
                  </button>
                </div>
              </div>
              <div className="text-center">
                <p className="text-xs uppercase tracking-widest text-moss mb-1">{item.type}</p>
                <h3 className="font-serif text-xl font-bold text-espresso mb-2 group-hover:text-moss transition-colors">{item.name}</h3>
                <p className="font-sans font-medium text-gray-600">${item.price.toFixed(2)}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <button className="border-b-2 border-espresso pb-1 font-bold uppercase tracking-wider text-sm hover:text-moss hover:border-moss transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-moss rounded-sm">
            View All Equipment
          </button>
        </div>
      </div>
    </section>
  );
};

export default Equipment;